<template>
  <div
    v-if="managers && managers.length"
    class="list-item add-agreeing d-flex align-center px-4"
    :class="{'add-agreeing__loading': withLoading}"
    data-qa="add-agreeing"
    @click="open">
    <sIcon
      class="list-item-icon my-auto mr-4"
      :type="options.icon"/>
    <div class="list-item-title text-start h11-links">
      {{ options.labelBtn }}
    </div>
    <DialogTemplateToolkit
      class-name="add-agreeing"
      :dialog="dialog"
      :disabled="load_managers"
      first_btn="Tenders.SendForApproval"
      :loading="withLoading || loading"
      :title="options.labelBtn"
      @apply="submit"
      @close="close">
      <template #card-text>
        <sForm
          ref="add-agreeing-form"
          :disabled="withLoading || loading"
          label-position="top"
          :model="formDate"
          :rules="rules">
          <div class="add-agreeing__acceptors">
            <div
              class="acceptors-list">
              <div class="add-agreeing__text pa-0 ma-0 mb-4 h5-headline">
                {{ $t('Tenders.Users') }}
              </div>
              <div
                v-for="(item, index) in formDate.acceptors"
                :key="item.contactId"
                class="acceptor">
                <PersonTooltip
                  :key="index"
                  class="ml-2 "
                  :name="item.name"
                  with_photo/>

                <div class="flex flex-right">
                  <sButton
                    data-qa="delete-acceptor"
                    :disabled="(item.status !=='WAITING' && item.status !== 'QUEUED' && !agreementEnded) || withLoading || loading"
                    icon="delete"
                    small
                    type="text"
                    @click="deleteAcceptor(item)"/>
                </div>
              </div>
            </div>

            <sFormItem
              v-if="add_new_acceptor"
              prop="acceptors">
              <div class="acceptor-select mt-2">
                <sSelect
                  class="add-agreeing__managers"
                  data-qa="manager"
                  :disabled="withLoading || loading || load_managers"
                  filterable
                  :loading="load_managers"
                  :placeholder="$t('Common.Select')"
                  :value.sync="formDate.acceptors[formDate.acceptors.length]"
                  value-key="contactId"
                  @update:value="setAcceptor">
                  <sOption
                    v-for="item in available_managers"
                    :key="`manager-${item.contactId}`"
                    :data-qa="`manager-${item.contactId}`"
                    :label="item.name"
                    :value="item"/>
                </sSelect>
                <sButton
                  v-if="formDate.acceptors.length"
                  class="mr-4"
                  data-qa="close-adding-acceptor"
                  :disabled="withLoading || loading"
                  icon="delete"
                  small
                  type="text"
                  @click="add_new_acceptor = false"/>
                <sProgress
                  v-else-if="load_managers"
                  class="ml-4 width-90 mb-0"
                  indeterminate
                  :stroke-width="2"
                  style="position: relative; top: -3px;"/>
              </div>
            </sFormItem>

            <sButton
              v-if="show_add_acceptor_btn || !formDate.acceptors.length"
              class="px-2 h10-links mb-6"
              data-qa="btn-add-lot"
              :disabled="withLoading || loading"
              icon="plus"
              icon-size="8px"
              small
              type="text"
              @click="addAcceptor">
              {{ $t('Common.AddOneMore') }}
            </sButton>
          </div>

          <div
            class="flex flex-between">
            <sFormItem
              prop="agreement_type">
              <template #label>
                <div class="add-agreeing__text pa-0 ma-0 mb-4 h5-headline">
                  {{ $t('Tenders.AgreementType') }}
                </div>
              </template>
              <sRadioGroup
                v-model="formDate.agreement_type"
                class="agreement_type-group  width-100 "
                data-qa="agreement_type-group">
                <sRadio
                  v-for="item in agreement_types"
                  :key="item.value"
                  class="agreement_type "
                  data-qa="agreement_type"
                  :label="item.value">
                  {{ item.title }}
                </sRadio>
              </sRadioGroup>
            </sFormItem>
            <sAlert
              v-if="formDate.agreement_type !== 'NONE'"
              style="width: 257px;">
              {{ $t(`Tenders.AgreementTypes.${formDate.agreement_type}`) }}
              <template slot="desc">
                {{ $t(`Tenders.AgreementTypes.${formDate.agreement_type}_Text`) }}
              </template>
            </sAlert>
          </div>
          <sFormItem
            :class="[{'is-required': comment_required}, 'mt-5']"
            prop="comment">
            <span
              slot="label"
              class="black--text h5-headline pb-3">{{ $t('Tenders.AgreementComment') }}</span>
            <sInput
              clearable
              :max-length="1500"
              max-rows="10"
              :placeholder="$t('Tenders.AgreementComment')"
              show-word-limit
              trim
              type="textarea"
              :value.sync="formDate.comment"/>
          </sFormItem>
          <sFormItem
            prop="moveTenderAfterAgreeSucceeded">
            <sTooltip
              v-if="!tariff || !isActiveMoveTenderAfterAgreeSucceeded"
              :border="false"
              class="mr-2"
              :content="!isActiveMoveTenderAfterAgreeSucceeded ? $t('Common.HintAfterAgreeSucceeded') : 'Заборонені дії по руху тендеру далі за відсутності тарифу'"
              type="white">
              <sIcon
                class="s-cell__validateIcon"
                type="info"/>
            </sTooltip>
            <sCheckbox
              v-model="formDate.moveTenderAfterAgreeSucceeded"
              class="agreement_type"
              data-qa="agreement_type"
              :disabled="!tariff || !isActiveMoveTenderAfterAgreeSucceeded">
              {{ $t('Tenders.TenderAfterAgree') }}
            </sCheckbox>
            <sCheckbox
              class="block mt-2"
              data-qa="isCancelTenderAfterReject"
              :disabled="!$can('cancel', 'Tender')"
              :value="formDate.isCancelTenderAfterReject"
              @input="val => setRootValue('isCancelTenderAfterReject', val)">
              {{ $t('Tenders.IsCancelTenderAfterReject') }}
            </sCheckbox>
          </sFormItem>
        </sForm>
      </template>
    </DialogTemplateToolkit>
    <DialogTemplateToolkit
      class-name="added-agreeing"
      :dialog.sync="added_dialog"
      :disabled="load_managers"
      first_btn="Common.ThankYou"
      :loading="withLoading || loading"
      :title="options.labelSuccess"
      without_second_btn
      @apply="closeAccepted"
      @close="close">
      <template #card-text>
        <div class="added-agreeing__subtitle pa-0 pb-3 h6-text">
          {{ $t('Tenders.ListOfAddedAcceptorsOfTender') }}
        </div>
        <template v-if="formDate.acceptors.length">
          <div
            v-for="(item, index) in formDate.acceptors"
            :key="item.contactId"
            class="acceptor flex flex-wrap">
            <PersonTooltip
              :key="index"
              class="ml-2 "
              :name="item.name"
              with_photo/>
          </div>
        </template>
        <div v-else>
          {{ $t('Common.NoData') }}
        </div>
      </template>
    </DialogTemplateToolkit>
  </div>
</template>
<script>
import PersonTooltip from 'components/common/blocks/PersonTooltip.vue'
import DialogTemplateToolkit from 'components/common/dialogs/DialogTemplateToolkit.vue'

import SmarttenderApi from '@/api/smarttenderApi'
const st_api = new SmarttenderApi()

import { tenderMixin } from 'mixins'

export default {
  name: 'addAdditionalAgreement',
  mixins: [tenderMixin],
  data() {
    const that = this
    return {
      tariff: null,
      loading: false,
      load_managers: false,
      load_agreement: false,
      dialog: false,
      added_dialog: false,
      add_new_acceptor: true,
      rules: {
        comment: {
          type: 'string',
          trigger: 'change',
          max: 1500,
          message: that.$t('Validate.maxLength', {number: 1500, type: that.$tc('Common.characters', 10) })
        },
        agreement_type: {
          trigger: 'change',
          message: that.$t('Validate.Required'),
          validator(rule, value, callback) {
            if (!value?.length || value === 'NONE') {
              callback(new Error(that.$t('Validate.Required')))
            }
            callback()
          }
        }
      },
      comment_required: false,
      managers: [],
      agreement_types: [
        { title: this.$t('Tenders.Parallel'), value: 'PARALLEL' },
        { title: this.$t('Tenders.Consistent'), value: 'CONSISTENTLY' },
      ],
      formDate: {
        agreement_type: 'PARALLEL',
        acceptors: [],
        comment: '',
        moveTenderAfterAgreeSucceeded: false,
        isCancelTenderAfterReject: false,
      },
      isActiveMoveTenderAfterAgreeSucceeded: false,
      agreementEnded: false,
    }
  },
  props: {
    tender: {
      type: Object,
      required: true
    },
    mode: {
      type: String,
      default: 'add',
      validator: function (value) {
        const correct = ['add', 'edit'].indexOf(value) !== -1
        return correct
      },
    },
    withLoading: {
      type: Boolean
    },
  },
  async mounted() {
    this.$store.dispatch('getContractNumberAndTariff')
      .then(res => {
        this.tariff = res?.tariff
      })
    this.managers = await this.$store.dispatch('tenderContactPersons')
    this.managers = this.agreements?.length ? this.managers?.filter(men => !this.agreements?.find(acce => acce?.contactId == men?.contactId)) : this.managers
  },
  computed: {
    agreements() {
      if (!this.$_stageAgreements?.length || this.$_stageAgreements.processEnded) {
        return []
      }
      return this.$_stageAgreements[0].agreements.filter(i => i.isAdditional)
    },
    options() {
      return {
        icon: this.mode === 'add' ? 'invite' : 'edit',
        labelBtn: this.mode === 'add' ? this.$t('Tenders.AddAgreeing') : this.$t('Tenders.EditAgreeing'),
        labelSuccess: this.mode === 'add' ? this.$t('Tenders.AdditionalAcceptorsSuccessfullyAdded') : this.$t('Tenders.AdditionalAcceptorsSuccessfullyEddited')
      }
    },
    show_add_acceptor_btn() {
      return !this.add_new_acceptor && this.formDate.acceptors?.length && this.available_managers?.length
    },
    available_managers() {
      return this.managers
        .filter(person => !this.formDate.acceptors.some(acceptor => acceptor.contactId == person.contactId ))
        .sort((a,b) => a.name?.localeCompare(b.name))
    }
  },
  methods: {
    submit() {
      this.$refs['add-agreeing-form'].validate(async (valid) => {
        if (!valid) { return }
        this.loading = true
        await st_api.startAdditionalTenderAgree({
          tenderId: this.tender.tenderId,
          comment: this.formDate.comment,
          type: this.formDate.agreement_type,
          contactIds: this.formDate.acceptors.map(item => item.contactId),
          moveTenderAfterAgreeSucceeded: this.formDate.moveTenderAfterAgreeSucceeded,
          isCancelTenderAfterReject: this.formDate.isCancelTenderAfterReject,
        })
          .then((result) => {
            this.added_dialog = true
            const resultObject = {
              agreements: result,
              comment: this.formDate.comment,
              tenderId: this.tender.tenderId,
              type: this.formDate.agreement_type,
            }
            this.$emit('updateAgreements', resultObject)
            this.close()
          })
          .catch(error => this.$log_error(error.message))
          .finally(() => {
            this.loading = false
          })
      })
    },
    close() {
      this.formDate.acceptors = []
      this.formDate.comment = ''
      this.formDate.agreement_type = 'PARALLEL'
      this.dialog = false
      this.added_dialog = false
    },
    closeAccepted() {
      this.formDate.acceptors = []
      this.added_dialog = false
    },
    async open() {
      if (this.withLoading) {
        return
      }
      this.isActiveMoveTenderAfterAgreeSucceeded = !this.agreements?.length || !this.agreements.find(i => !i.isAdditional)
      this.agreementEnded = this.tender.agreementEnded || false
      this.formDate.agreement_type = this.tender.acceptorType || 'PARALLEL'
      this.formDate.comment = this.tender.acceptorComment || ''
      if (this.agreements?.length) {
        this.agreements.filter(i => i.isAdditional).forEach(agreement => {
          const item = this.$_.cloneDeep(agreement)
          item.name = item.fio
          item.exists = true
          this.formDate.acceptors.push(item)
          agreement
        })
      }
      setTimeout( () => {
        this.dialog = true
      }, 200)
    },
    addAcceptor() {
      this.add_new_acceptor = true
    },
    setAcceptor() {
      this.formDate.acceptors[this.formDate.acceptors.length - 1].status = 'WAITING'
      this.add_new_acceptor = false
    },
    deleteAcceptor(item) {
      if (!this.agreementEnded && item.status !== 'WAITING' && item.status !== 'QUEUED') {
        return
      }
      this.formDate.acceptors = this.formDate.acceptors.filter(accept => accept.contactId != item.contactId)
    }
  },
  components: {
    PersonTooltip,
    DialogTemplateToolkit
  }
}
</script>
<style lang="scss" scoped>
.acceptors-list {
  max-height: 400px;
  overflow: auto;
}
.list-item {
  cursor: pointer;
  position: relative;
  min-height: 40px;
  &:hover:not(.add-agreeing__loading) {
    background: var(--color-main-green);
    transition: 0.25s all;
    &::before {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      opacity: 0.3;
      background-color: var(--v-secondary__green_chosen-darken1);
    }
  }
}
.acceptor {
  background-color: var(--v-secondary__green_chosen-base);
  border-color: var(--v-secondary__green_chosen-base);
  border-radius: 8px;
  padding: 5px 20px;
  margin-bottom: 9px;
  justify-content: space-between;
  display: flex;
  &-required {
    text-transform: uppercase;
    margin: auto 24px auto 0;
  }
  &-select {
    padding: 0px 5px 0px 0px;
    justify-content: space-between;
    display: flex;
  }
}
.add-agreeing{
  &__managers {
    width: calc(100% - 47px);
  }
  &__loading {
    color: #bed4d3;
    cursor: default;
  }
}
</style>
